export const REQUEST_CANCELED = 'REQUEST_CANCELED';
